"use client";

import { useMemo } from "react";
import { useUser } from "../providers/user-provider";
import { roleUserVerification } from "../utils/role-user-verification";
import { CAN_ACCESS_COURSES_ADMIN } from "../constants/permissions-const";
import { backofficeMessagesPath, clientMessagesPath } from "../paths/paths";

/**
 * Où mène la messagerie pour l'utilisateur courant.
 *
 * Les deux espaces montrent les mêmes fils — le backend filtre — mais pas de la
 * même façon : le back-office a besoin de savoir de quelle course et de quel
 * côté il s'agit, là où un client n'a qu'une discussion par course.
 */
export const useMessageriePath = () => {
  const { me } = useUser();

  return useMemo(() => {
    const estBackOffice = !!roleUserVerification(me?.role, [
      CAN_ACCESS_COURSES_ADMIN,
    ]);

    return {
      estBackOffice,
      cheminMessagerie: estBackOffice
        ? backofficeMessagesPath
        : clientMessagesPath,
    };
  }, [me?.role]);
};
